import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';
import queryString from 'query-string';

export const getUser = createAsyncThunk('userSlice/getUser', async (data) => {
    try {
        // showLoader(true);
        const query = queryString.stringify(data);

        let response = await axios.get('/user' + `?${query}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        // showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        // showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createUser = createAsyncThunk('userSlice/createUser', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/user', data, {
            headers: {
                'Content-Type': 'application/json',
                firebase: `${data?.token}`
            }
        });
        toast.success(response?.data?.message || 'User created successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateUser = createAsyncThunk('userSlice/updateUser', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/user/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User updated successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getUserById = createAsyncThunk('userSlice/getUserById', async (id) => {
    try {
        showLoader(true);

        let response = await axios.get('/user/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteUser = createAsyncThunk('userSlice/deleteUser', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/user/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User deleted successfully');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateStatus = createAsyncThunk('userSlice/updateStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/user/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getUser());

        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
///** User Password Reset Api

export const updateUserPassword = createAsyncThunk('userSlice/updateUserPassword', async (data) => {
    try {
        let response = await axios.put('/admin/user-reset-password/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'User Password reset successfully!');
        return Promise.resolve(response);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const userLogin = createAsyncThunk('userSlice/userLogin', async (id) => {
    try {
        let response = await axios.get('/user-wise-login/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        return Promise.resolve(response?.data);
    } catch (err) {
        console.log('err', err);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getRtoOptions = createAsyncThunk('userSlice/getRtoOptions', async () => {
    try {
        showLoader(true);

        let response = await axios.get('/rto?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response?.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getDistrictOptions = createAsyncThunk('userSlice/getDistrictOptions', async (stateOfficeId) => {
    try {
        showLoader(true);
        let response = await axios.get('/district-office?option=true&stateOfficeId=' + `${stateOfficeId}`, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response?.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getStateOptions = createAsyncThunk('userSlice/getStateOptions', async () => {
    try {
        showLoader(true);

        let response = await axios.get('/state-office?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response?.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const getDepoOptions = createAsyncThunk('userSlice/getDepoOptions', async (data) => {
    try {
        showLoader(true);

        const query = queryString.stringify({ ...data, option: true });
        let response = await axios.get('/depo-office?' + query, {
            headers: {
                'Content-Type': 'application/json'
            }
        });

        showLoader(false);
        return Promise.resolve(response?.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const userSlice = createSlice({
    name: 'userSlice',
    initialState: {
        data: [],
        rtoOptions: [],
        districtOptions: [],
        stateOptions: [],
        depoOptions: [],
        selectedUser: {}
    },
    reducers: {
        handleSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },
        removeSelectedUser: (state, action) => {
            state.selectedUser = {};
        },
        removeDistrictOptions: (state, action) => {
            state.districtOptions = [];
        },
        removeStateOptions: (state, action) => {
            state.stateOptions = [];
        },
        removeDepoOptions: (state, action) => {
            state.depoOptions = [];
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getUser.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getUserById.fulfilled, (state, action) => {
            state.selectedUser = action.payload;
            return;
        });
        builder.addCase(getRtoOptions.fulfilled, (state, action) => {
            state.rtoOptions = action.payload;
            return;
        });
        builder.addCase(getDistrictOptions.fulfilled, (state, action) => {
            state.districtOptions = action.payload;
            return;
        });
        builder.addCase(getStateOptions.fulfilled, (state, action) => {
            state.stateOptions = action.payload;
            return;
        });
        builder.addCase(getDepoOptions.fulfilled, (state, action) => {
            state.depoOptions = action.payload;
            return;
        });
    }
});

export const { handleSelectedUser, removeSelectedUser, removeDistrictOptions, removeStateOptions, removeDepoOptions } = userSlice.actions;

export default userSlice.reducer;
